import React from 'react'
import styled from 'styled-components'
import Slider from './'
import PropTypes from 'prop-types'
import { device } from '../../../utils/helpers'

const Wrapper = styled.section`
  width: 100%;
  display: flex;
  flex-direction: ${props => props.reverseMobile ? 'column-reverse' : 'column'};

  @media ${device.laptop} {
    display: grid;
    width: 100%;
    grid-template-columns: 50% 50%;
    grid-template-areas: ${props => props.reverse ? `'slider content'` : `'content slider'`};
    height: 580px;
  }
`

const Content = styled.div`
  padding: 3.5rem 1.5rem 6rem 1.5rem;
  grid-area: content;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media ${device.laptop} {
    padding: 2rem 4rem;
  }

  @media ${device.desktop} {
    padding: 3rem 4rem;
  }

  ${'' /* @media ${device.desktop} {
    padding: 5rem 7.5rem;
  } */}
`

const SliderContainer = styled.div`
  width: 100%;
  grid-area: slider;
`

const SplitSection = ({ slides, children, ...props }) =>
  <Wrapper {...props}>
    <Content>
      {children}
    </Content>
    <SliderContainer>
      <Slider slides={slides} dots={false} />
    </SliderContainer>
  </Wrapper>

SplitSection.propTypes = {
  /**
   * Slides for the slider
   */
  slides: PropTypes.array.isRequired,
  /**
   * Switches order of slide section and content
   */
  reverse: PropTypes.bool
}

export default SplitSection



// WEBPACK FOOTER //
// ./src/components/UI/Slider/SplitSection.js